@import "node_modules/@se/web-ui/styles/se-variable";

.cta-widget {
  box-sizing: border-box;
  flex-grow: 1;
  background-color: white;
  text-decoration: none;
  padding: 19px 20px 20px;
  border: 2px solid white;
  height: 100%;

  &-link {
    flex-grow: 1;
    display: block;
    height: 100%;
  }

  &--dashboard {
    display: flex;
    flex-flow: column nowrap;
    height: 100%;

    .cta-widget-footer {
      margin-top: 8px;
    }

    .support-icon {
      margin-top: 4px;
    }

    .subtitle2 {
      grid-column-start: 1;
      grid-column-end: 3;
      grid-row-start: 2;
      grid-row-end: 2;
      align-items: end;
      padding-top: 16px;
    }

    .subtitle1 {
      align-content: end;
      padding-bottom: 10px;
    }
  }

  &--mobile {
    height: 100%;
    padding: 16px;

    .support-link {
      margin: 8px;
    }

    .support-icon {
      grid-column-start: 1;
      grid-column-end: 1;
      grid-row-start: 1;
      grid-row-end: 3;

      align-items: center;
    }

    .subtitle1 {
      align-content: end;
    }

    .subtitle2 {
      padding-top: 8px;
      grid-column-start: 2;
      grid-column-end: 2;
      grid-row-start: 2;
      grid-row-end: 2;
    }

    .cta-widget-footer {
      margin-top: 8px;
      text-align: right;
    }
  }
}

.cta-widget-grid {
  display: grid;
  grid-template-columns: 52px auto;
  grid-template-rows: auto 1fr;

  & > * {
    margin: 0;
  }
}

.cta-widget-link:focus {
  .cta-widget {
    border: 2px solid black;
  }
}

.cta-widget:hover {
  box-shadow: 0px 2px 10px 0px rgba(51, 51, 51, 0.12);
  .support-link {
    text-decoration: underline;
  }
}
.support-icon {
  margin-left: -8px;
  color: var(--qds-theme-signature-color-default, #008a16);
  &-dashboard {
    @extend .support-icon;
    margin-left: 0;
  }
}
.subtitle1 {
  font-size: 18px;
  font-weight: bold;
  //margin-top: 20px;
  color: #333333;
  margin-bottom: 0;

  &-dashboard {
    @extend .subtitle1;
    margin: 0 12px;
    line-height: 30px;
  }
}

.subtitle2 {
  font-size: 14px;
  //margin-top: 15px;
  margin-bottom: 0px;
  color: #333333;
  white-space: break-spaces;

  &-dashboard {
    @extend .subtitle2;
    margin: 0 12px;
    line-height: 20px;
  }
}

.flex-spacer {
  flex-grow: 1;
}

.cta-widget-footer {
  margin-top: 25px;
}

.support-link {
  margin: 0;
  text-decoration: none;
  font-size: 16px;
  color: #1a0dab;
  &-dashboard {
    @extend .support-link;
    line-height: 22px;
    display: flex;
    flex-flow: row-reverse;
    padding-top: 9px;
    margin: 0;
  }
}

.link {
  text-decoration: none;
}

.cta-widget-header {
  display: flex;
  & .support-icon {
    @extend .support-icon;
    margin-right: 10px;
  }
}
